export default function EditorBanner() {
  return (
    <section className="w-full px-4 md:px-8 py-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {/* Destaque grande */}
        <a
          href="#editor-picks"
          className="group relative md:col-span-2 aspect-[2/1] md:aspect-[2.1/1] rounded-lg overflow-hidden bg-background-100 cursor-pointer"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Realistic%20editorial%20home%20interior%20photograph%20of%20a%20warm%20cozy%20living%20room%20corner%20with%20handmade%20ceramic%20pottery%20a%20woven%20wool%20throw%20blanket%20and%20natural%20wood%20shelves%2C%20soft%20afternoon%20daylight%20coming%20through%20a%20window%2C%20muted%20earthy%20palette%2C%20documentary%20lifestyle%20photography%2C%20realistic%20shadows%20and%20detail&width=1600&height=760&seq=casaflor-banner-editor&orientation=landscape"
            alt="Seleção da editora"
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/55 via-foreground-950/15 to-transparent"></div>
          <div className="absolute inset-0 flex items-center p-6 md:p-10">
            <div className="max-w-md">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/95 text-[11px] tracking-wider uppercase text-foreground-800 mb-3">
                <i className="ri-star-line text-[12px]"></i>
                Seleção
              </span>
              <h3 className="font-heading text-background-50 text-2xl md:text-4xl font-medium leading-tight">
                Seleção do mês
              </h3>
              <span className="inline-flex items-center gap-1.5 mt-5 text-background-50 text-[13.5px] font-medium">
                Ver a seleção
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </a>

        {/* Pilha lateral */}
        <div className="grid grid-cols-1 gap-4 md:gap-5">
          <a
            href="#gift-guide"
            className="group relative aspect-[2.2/1] md:aspect-auto rounded-lg overflow-hidden bg-background-100 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Realistic%20product%20flatlay%20photograph%20of%20a%20small%20handmade%20gift%20box%20wrapped%20in%20kraft%20paper%20with%20a%20dried%20flower%20and%20handwritten%20note%20on%20a%20wooden%20surface%2C%20warm%20natural%20daylight%2C%20documentary%20product%20photography%2C%20muted%20earth%20palette&width=900&height=500&seq=casaflor-banner-gift&orientation=landscape"
              alt="Presentes"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5">
              <p className="font-heading text-background-50 text-lg md:text-xl font-medium leading-tight">
                Presentes até R$ 150
              </p>
              <span className="inline-flex items-center gap-1 mt-1 text-background-50 text-[12.5px]">
                Comprar
                <i className="ri-arrow-right-line text-[14px]"></i>
              </span>
            </div>
          </a>
          <a
            href="#vintage"
            className="group relative aspect-[2.2/1] md:aspect-auto rounded-lg overflow-hidden bg-background-100 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Realistic%20photograph%20of%20vintage%20home%20decor%20objects%20on%20a%20wooden%20shelf%20brass%20candlestick%20old%20book%20small%20ceramic%20vessel%20with%20dried%20herbs%2C%20warm%20afternoon%20natural%20light%2C%20documentary%20vintage%20listing%20photography%2C%20muted%20earth%20palette%20realistic%20detail&width=900&height=500&seq=casaflor-banner-vintage&orientation=landscape"
              alt="Retrô"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5">
              <p className="font-heading text-background-50 text-lg md:text-xl font-medium leading-tight">
                Retrô
              </p>
              <span className="inline-flex items-center gap-1 mt-1 text-background-50 text-[12.5px]">
                Comprar
                <i className="ri-arrow-right-line text-[14px]"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}